/// <reference path="../_references.ts"/>

module App.Administrative.PurchaseOrder {
	export class PurchaseOrderService {
		constructor(
			private $http: ng.IHttpService,
			private Constants: IConstants
		) {

		}

		create(purchaseOrder: PO): ng.IHttpPromise<PO> {
			return this.$http.post(`${this.Constants.apiUrl}purchaseorder`, purchaseOrder);
		}

		getTypes(): ng.IHttpPromise<PurchaseOrderType[]> {
			return this.$http.get(`${this.Constants.apiUrl}purchaseordertype`);
		}

		getAll(serviceRequestId?: number): ng.IHttpPromise<PO[]> {
			let query: {[key:string]: number} = {};
			if (angular.isDefined(serviceRequestId)) {
					query.service_request = serviceRequestId;
			}
			return this.$http.get(`${this.Constants.apiUrl}purchaseorder`, {
				params: query
			});
		}

		public static Factory() {
			let instance = ($http: ng.IHttpService, Constants: IConstants) => {
				return new PurchaseOrderService($http, Constants);
			};

			instance.$inject = ['$http', 'Constants'];

			return instance;
		}
	}
}
